import formatters from './formatters'
import getCurrentScopeByUri from './getCurrentScopeByUri'
import resolveListPath from './resolveListPath'

const contentHeader = {
  formatters,
  getCurrentScopeByUri,
  resolveListPath,
}

export default contentHeader
